import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  historyPopup: {
    '& .popup__box': {
      maxWidth: 720,
      width: '100%'
    }
  },

  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },

  historyCard: {
    border: '1px solid ' + `${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: theme.app.borderRadius.md,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 14,

    cursor: 'pointer'
  },

  historyRowHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8
  },

  historyRowContent: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'flex-start',
    gap: 8,
    flexDirection: 'column'
  },

  historyAnimalNameIcon: {
    width: 24,
    height: 20,
    marginRight: 8,

    '& path': {
      fill: `${theme.palette.primary.main}`
    }
  },

  historyAnimalName: {
    fontSize: theme.app.typography.label.fontSize,
    color: theme.app.colors.text.primary
  },

  historyDate: {
    fontSize: theme.app.typography.label.fontSize,
    color: '#6D6D6D'
  },

  reproductionBadge: {
    borderRadius: 5,
    padding: 8,
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 500,
    color: '#fff',
    backgroundColor: `${theme.palette.primary.main}`
  },

  pendingBadge: {
    borderRadius: 5,
    padding: 8,
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 500,
    color: '#fff200',
    backgroundColor: `${theme.palette.primary.main}`
  }
}))
